import { useSearchParams } from 'react-router-dom'

import {
  FiChevronLeft,
  FiChevronRight
} from 'react-icons/fi'

const Header = () => {
  const [ searchParams ] = useSearchParams()

  const time = searchParams.get( 'time' )

  const prev = () => {
    console.log( 'prev' )
  }

  const next = () => {
    console.log( 'next' )
  }

  if ( time === 'all' || ! time )
    return null

  if ( time === 'yearly' ) {
    return <div className="bar">
      <button
        onClick={ prev }
      >
        <FiChevronLeft />
      </button>

      <h1 className="ta-center">2026</h1>

      <button
        onClick={ next }
      >
        <FiChevronRight />
      </button>

    </div>
  }

  if ( time === 'monthly' ) {
    return <div className="bar">
      <button
        onClick={ prev }
      >
        <FiChevronLeft />
      </button>

      <h1 className="ta-center">jan 2026</h1>

      <button
        onClick={ next }
      >
        <FiChevronRight />
      </button>

    </div>
  }

  if ( time === 'weekly' ) {
    return <div className="bar">
      <button
        onClick={ prev }
      >
        <FiChevronLeft />
      </button>

      <h1 className="ta-center">week 4 2026</h1>

      <button
        onClick={ next }
      >
        <FiChevronRight />
      </button>

    </div>
  }

  return <>header</>
}

export default Header
